// src/components/Hero.jsx
import React from 'react';
import heroBg from '../assets/foto_hero.jpg'; // Ajusta la ruta real a tu imagen
import '../styles/Hero.css';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const el = document.getElementById('contacto');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="hero-section">
      {/* Overlay degradado */}
      <div className="hero-overlay"></div>

      {/* Contenedor de texto y botón */}
      <div className="hero-content">
        <h1 className="hero-title">FVS Catering</h1>
        <p className="hero-subtitle">
          Lleva tu evento al siguiente nivel con nuestro servicio de catering
        </p>
        <button className="hero-button" onClick={scrollToContact}>
          Solicita una Cotización
        </button>
      </div>
    </section>
  );
};

export default Hero;
  